import { LayerIds, ProjectStatus } from "fond/types";

/**
 * Return the design edits that are present in the project.
 */
export const getDesignEdits = (status: ProjectStatus | undefined) => {
  const files = status?.InputFiles;
  const hasMovedHubs = Boolean((files?.cabinet && files?.closure) || (files?.t1_hub_geometry && files?.t2_hub_geometry));
  const hasDropAssignments = Boolean(files?.[LayerIds.dropAssignment]);
  const hasBlockers = Boolean(files?.[LayerIds.blocker]);

  return { hasMovedHubs, hasDropAssignments, hasBlockers, hasEdits: hasMovedHubs || hasDropAssignments || hasBlockers };
};
